// src/hooks/useProductPageContent.js
import { useState } from "react";
import { getProductCategory, getProductCategoryByUser, getProductCategoryByShop } from "../services/productService";

const useProductCategory = () => {
  const [status, setStatus] = useState("idle"); // idle | loading | done | error
  const [error, setError] = useState("");
  const [data, setData] = useState([]);
  const [dataOptions, setDataOptions] = useState([]);

  const fetchProductCategory = async () => {
    setStatus("loading");
    setError("");

    try {
      const response = await getProductCategory();

      if (response?.status !== "Error") {
        // console.log("fetch category data",response.data)
        setData(response.data ?? response); // depending on API shape
        setDataOptions(
          (response.data ?? response).map((item) => ({
            label: item.name,
            value: item.id,
          }))
        );
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };

  const fetchProductCategoryByUser = async (id) => {
    setStatus("loading");
    setError("");

    try {
      const response = await getProductCategoryByUser(id);

      if (response?.status !== "Error") {
        // console.log("fetch category data",response.data)
        setData(response.data ?? response); // depending on API shape
        setDataOptions(
          (response.data ?? response).map((item) => ({
            label: item.name,
            value: item.id,
          }))
        );
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };


  
    const fetchProductCategoryByShop = async (id) => {
    setStatus("loading");
    setError("");

    try {
      const response = await getProductCategoryByShop(id);

      if (response?.status !== "Error") {
        // console.log("fetch category data",response.data)
        setData(response.data ?? response); // depending on API shape
        setDataOptions(
          (response.data ?? response).map((item) => ({
            label: item.name,
            value: item.id,
          }))
        );
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };




  const resetStatus = () => {
    setStatus("idle");
    setError("");
  };

  return {
    fetchProductCategory,
    fetchProductCategoryByUser,
    fetchProductCategoryByShop,
    data,
    dataOptions,
    status,
    error,
    resetStatus,
  };
};

export default useProductCategory;
